import { SelectOptionsWithId } from '@/ui/types';

export const filterEntityFolderLabelsToOptions = <T = string>({ data }: { data: BaseFilterEntity[] }): SelectOptionsWithId<T> => data.map(
  item => ({
    id: item.id as number,
    value: item.title as unknown as T,
    label: item.title,
  }),
);
